import React from 'react';
import { updateLibraryCreativeError, updateLibraryCreativeSuccess } from 'modules/creative-library/actions';
import { addIndication, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { creativesLibraryApi } from 'services/api';
import { generateErrorIndication } from 'services/utils/errorMessagesUtils';

export const successIndication = {
    message: <FormattedMessage id="creative-library.save.success" defaultMessage="Creative successfully updated" />,
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

export const errorMessage = (
    <FormattedMessage
        id="creative-library.save.error"
        defaultMessage="We were not able to save changes to the creative"
    />
);

const updateCreative = async (creative, updateCreativeCall, accountId, creativeChanges) => {
    const { id: creativeId } = creative;
    return await updateCreativeCall(accountId, creativeId, creativeChanges);
};

const updateLibraryCreativeBase = updateCreativeCall => (accountId, creative, creativeChanges) => async dispatch => {
    try {
        const result = await updateCreative(creative, updateCreativeCall, accountId, creativeChanges);
        dispatch(updateLibraryCreativeSuccess(result));
        dispatch(addIndication(successIndication));
        return { result };
    } catch (error) {
        dispatch(updateLibraryCreativeError(creative.id, error));
        dispatch(addIndication(generateErrorIndication(error, errorMessage)));
        throw error;
    }
};

export const updateLibraryCreative = updateLibraryCreativeBase(creativesLibraryApi.updateLibraryCreative);
